import { on } from "@ngrx/store";
import { DeveloperState } from "../developer.state";
import { WebhookActions } from "./webhooks.actions";
import { PagesStore } from "../../../pages.state";

function withDeveloper(state: PagesStore, updater: (developer: DeveloperState) => DeveloperState): PagesStore {
    return { ...state, developer: updater(state.developer) };
}

const loadWebhooks = on(WebhookActions.loadWebhooks, (state: PagesStore) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, loading: true } })));

const loadWebhooksSuccess = on(WebhookActions.loadWebhooksSuccess, (state: PagesStore, { webhooks }) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, webhooks, loading: false } })));

const loadWebhooksFailure = on(WebhookActions.loadWebhooksFailure, (state: PagesStore) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, loading: false } })));

const getWebhook = on(WebhookActions.getWebhook, (state: PagesStore) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, selectedWebhook: undefined, detailLoading: true } })));

const getWebhookSuccess = on(WebhookActions.getWebhookSuccess, (state: PagesStore, { webhook }) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, selectedWebhook: webhook, detailLoading: false } })));

const getWebhookFailure = on(WebhookActions.getWebhookFailure, (state: PagesStore) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, detailLoading: false } })));

const createWebhook = on(WebhookActions.createWebhook, (state: PagesStore) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, loading: true } })));

const createWebhookSuccess = on(WebhookActions.createWebhookSuccess, (state: PagesStore) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, loading: false } })));

const createWebhookFailure = on(WebhookActions.createWebhookFailure, (state: PagesStore) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, loading: false } })));

const updateWebhook = on(WebhookActions.updateWebhook, (state: PagesStore) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, detailLoading: true } })));

const updateWebhookSuccess = on(WebhookActions.updateWebhookSuccess, (state: PagesStore) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, detailLoading: false } })));

const updateWebhookFailure = on(WebhookActions.updateWebhookFailure, (state: PagesStore) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, detailLoading: false } })));

const deleteWebhook = on(WebhookActions.deleteWebhook, (state: PagesStore) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, loading: true } })));

const deleteWebhookSuccess = on(WebhookActions.deleteWebhookSuccess, (state: PagesStore, { webhookId }) =>
    withDeveloper(state, dev => ({
        ...dev,
        webhooks: {
            ...dev.webhooks,
            loading: false,
            webhooks: dev.webhooks.webhooks?.filter(w => w.id?.webhook_id !== webhookId),
        },
    })));

const deleteWebhookFailure = on(WebhookActions.deleteWebhookFailure, (state: PagesStore) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, loading: false } })));

const clearSelectedWebhook = on(WebhookActions.clearSelectedWebhook, (state: PagesStore) =>
    withDeveloper(state, dev => ({ ...dev, webhooks: { ...dev.webhooks, selectedWebhook: undefined } })));

export const webhooksReducer = [
    loadWebhooks,
    loadWebhooksSuccess,
    loadWebhooksFailure,
    getWebhook,
    getWebhookSuccess,
    getWebhookFailure,
    createWebhook,
    createWebhookSuccess,
    createWebhookFailure,
    updateWebhook,
    updateWebhookSuccess,
    updateWebhookFailure,
    deleteWebhook,
    deleteWebhookSuccess,
    deleteWebhookFailure,
    clearSelectedWebhook,
];
